import { render, staticRenderFns } from "./TemplateImage.vue?vue&type=template&id=24282d27&"
import script from "./TemplateImage.vue?vue&type=script&lang=ts&"
export * from "./TemplateImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports